import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
const MyDropdownToggle = () => (
  <Dropdown.Toggle
    size="sm"
    style={{ backgroundColor: 'inherit', border: 'none', color: 'grey' }}
  ></Dropdown.Toggle>
);
export default MyDropdownToggle;
